<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/9/2020
  -->

<template>
	<FormRow
		class="form-checkbox-row-root"
		:prop="prop"
		:title="title"
		v-bind="$attrs"
		:tooltipText="tooltipText"
		:tooltip-position="tooltipPosition"
		:showDivider="showDivider">

		<el-checkbox
			v-model="valueData"
			v-bind="$attrs"
			@change="notifyValueChanged">
            <slot>
                {{name}}
            </slot>
		</el-checkbox>
		<slot name="postfix"></slot>


	</FormRow>

</template>

<script>
	import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue"
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import FormRow from "@/core/components/Form/Base/FormRow.vue";

	export default {
		name: "FormCheckboxRow",
		components: {FormRow, ToolTipView},
		extends: BaseFormRow,
		props: {
			name:String,
		},

		methods:{
			click(event){
				// if(this.disableClick){
				// 	event.preventDefault()
				// }
			},

			formatDataIn(data){
				return !!data
			}
		}
	}
</script>

<style lang="scss">

.checkbox-align-top{
	&.form-checkbox-row-root{
		.el-checkbox__input {
			vertical-align: top;
			margin-top: 11px;
		}
	}
}
//.qwoach-form
</style>
